import { Navigate, Route } from 'react-router-dom';
import { AgentLayout } from '@/components/layout/AgentLayout';
import { AgentDashboard, AgentCall, AgentHistory, AgentCallbacks, AgentProfile } from './pages';
import { MyPhonePage } from '@/pages/me/MyPhone';

export const agentRoutes = {
  layout: <AgentLayout />,
  children: (<>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard" element={<AgentDashboard />} />
    <Route path="call" element={<AgentCall />} />
    <Route path="history" element={<AgentHistory />} />
    <Route path="callbacks" element={<AgentCallbacks />} />
    <Route path="profile" element={<AgentProfile />} />
    {/* Both mode: the agent's PBX extension (docs/PBX.md) */}
    <Route path="my-phone" element={<MyPhonePage />} />
  </>),
};
